/**
 * One-shot banner after deploy: hard-refresh clears SW + HTML cache 404 ghosts.
 */
import { useEffect, useState } from "react";

const KEY = "budb_seen_build";

export function HardRefreshBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem(KEY);
      void fetch("/api")
        .then((r) => r.json())
        .then((j: { version?: string }) => {
          const v = j.version || "1.9.4";
          if (seen !== v) {
            setShow(true);
            localStorage.setItem(KEY, v);
          }
        })
        .catch(() => {
          /* ignore */
        });
    } catch {
      /* ignore */
    }
  }, []);

  if (!show) return null;

  return (
    <div
      className="w-full px-3 py-1.5 text-center text-[11px] font-medium"
      style={{
        background: "rgba(15,40,30,0.95)",
        color: "#a7f3d0",
        borderBottom: "1px solid rgba(52,211,153,0.25)",
      }}
      data-testid="hard-refresh-banner"
    >
      Updated build — if menus or tables look wrong, hard-refresh (
      <kbd className="px-1 rounded bg-black/30">Ctrl</kbd>+
      <kbd className="px-1 rounded bg-black/30">Shift</kbd>+
      <kbd className="px-1 rounded bg-black/30">R</kbd>
      ) so service worker cache clears.{" "}
      <button
        type="button"
        className="underline text-emerald-200 ml-1"
        onClick={() => setShow(false)}
      >
        Dismiss
      </button>
    </div>
  );
}
